import { createFileRoute } from "@tanstack/react-router";

import CompanyPage from "@/components/[routes]/company/company-page";
import { RouteGuards } from "@/core/auth/route-guards";

export const Route = createFileRoute("/_secure/companies")({
  beforeLoad: RouteGuards.adminOnly(),
  component: CompanyPage,
});
